export const isUSLocale = process.env.REACT_APP_LOCALE
  ? process.env.REACT_APP_LOCALE === "us"
  : true;
